export enum UserStatusEnum {
  ACTIVATED = "ACTIVATED",
  NO_ACCOUNT = "NO_ACCOUNT",
  PENDING_COMPANY_INFORMATION = "PENDING_COMPANY_INFORMATION",
  PENDING_VALIDATION_INFORMATION = "PENDING_VALIDATION_INFORMATION",
  PENDING_MANUAL_ACTIVATION = "PENDING_MANUAL_ACTIVATION",
  DISABLED = "DISABLED",
  DELETED = "DELETED",
}
